exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-6639da59] .v-selection-control__input {\n  display: none;\n}\n", ""]);

// exports
